import React, { useMemo, useState } from "react";
import { ChevronDown, Search, Check } from "lucide-react";

// Lightweight searchable single-select dropdown.
const SearchableSelect = ({ value, onChange, options, placeholder = "Select…", disabled = false }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const filtered = useMemo(() => {
    if (!query) return options;
    const q = query.toLowerCase();
    return options.filter(o => o.toLowerCase().includes(q));
  }, [options, query]);
  return (
    <div className="relative">
      <button type="button" disabled={disabled} onClick={() => setOpen(v => !v)} className="w-full flex items-center justify-between gap-2 px-3 py-2 rounded-md bg-white border text-[14px] text-left" style={{ borderColor: 'rgba(13,42,32,0.15)' }}>
        <span className={value ? "text-[#0d2a20]" : "text-[#0d2a20]/50"}>{value || placeholder}</span>
        <ChevronDown size={16} className="text-[#0d2a20]/50" />
      </button>
      {open && (
        <div className="absolute z-30 mt-1 w-full rounded-md border shadow-lg overflow-hidden" style={{ background: 'white', borderColor: 'rgba(13,42,32,0.15)' }}>
          <div className="relative border-b" style={{ borderColor: 'rgba(13,42,32,0.08)' }}>
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#0d2a20]/40" />
            <input autoFocus value={query} onChange={e => setQuery(e.target.value)} placeholder="Type to search…" className="w-full pl-9 pr-3 py-2 text-[13px] bg-transparent focus:outline-none" />
          </div>
          <div className="max-h-56 overflow-y-auto">
            {filtered.length === 0 ? (
              <div className="px-3 py-3 text-[13px] text-[#0d2a20]/60">No matches</div>
            ) : filtered.map(o => (
              <button type="button" key={o} onClick={() => { onChange(o); setOpen(false); setQuery(""); }} className={`w-full text-left px-3 py-2 text-[13px] flex items-center justify-between hover:bg-[#f4efe4] ${o === value ? 'bg-[#f4efe4]' : ''}`}>
                <span>{o}</span>
                {o === value && <Check size={14} className="text-[#e0684d]" />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
